import { MdMenu } from 'react-icons/md';
import { useMenu } from 'hooks';
import * as S from './styles';

export function Hamburger() {
  const { retractableBreakPoint, setShowMenu } = useMenu();

  function openMenu() {
    setShowMenu(true);
  }

  return (
    <S.HamburgerButton $breakPoint={retractableBreakPoint} onClick={openMenu}>
      <MdMenu />
    </S.HamburgerButton>
  );
}
